import mitt from "mitt";

const eventBus = mitt<Record<string, unknown>>();

export default eventBus;
